import React from 'react'
import {ContentCardsProps, contentCard} from './types'
import {Card} from './content-card'
import {Button} from '@/components/cta'

const ContentCards = (props: ContentCardsProps) => {
    const cards = props.contentCard || []
    const totalCards = props.contentCard?.length || 0
    const urlLink = props.external
        ? props.external_link?.value?.data?.url ?? '#'
        : props.link?.value?.data?.url ?? '#'
    return (
        <div className="cards-content-section flex flex-col mt-[16px] mb-[16px] gap-y-lg">
            <div className="content-cards-title">
                {props.heading && (
                    <div
                        className="text-center text-size-225 min-h-[43px] font-medium  lg:text-size-heading-lg "
                        dangerouslySetInnerHTML={{__html: props.heading ?? ''}}
                    ></div>
                )}
            </div>
            <div className="grid grid-cols-2 gap-[9px]  max-w-[349px] mx-auto sm:grid-cols-3 sm:max-w-none xl:gap-[24px]">
                {cards.map((card: contentCard, index) => (
                    <Card key={index} {...card} index={index} totalCards={totalCards} />
                ))}
            </div>
            <div className="content-cards-text-section mx-auto flex gap-y-lg flex-col items-center justify-start sm:items-start lg:items-center lg:justify-center max-w-[1236px]  mt-[16px]  lg:flex-row lg:mx-auto">
                <div
                    className="text-content  text-left flex justify-center items-center w-full max-w-[340px] sm:max-w-[705px] xl:max-w-[75%] "
                    dangerouslySetInnerHTML={props.text ? {__html: props.text} : undefined}
                ></div>
                <div className="button-container  w-full flex items-start justify-center  sm:justify-start sm:items-start  lg:justify-center lg:items-center lg:max-w-[25%]">
                    {props.ctaText && (
                        <Button
                            clickFunction="link"
                            variant="primary"
                            ctaType="button"
                            url={urlLink}
                            style={{backgroundColor: props.buttonColor}}
                        >
                            {props.ctaText}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ContentCards
